<template>
    <zk-admin-table title="精准关怀体检报告上传" :loading="loading" :table="table" @change="handleTableChange">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button type="default" size="small" @click="handleExport" icon="el-icon-download">导出</el-button>
                <el-button type="default" size="small" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </el-row>
        </template>

        <template v-slot:search>
            <zk-search-form-inline :form="search" @search="() => { table.page = 1; getData() }">
                <el-form-item label="姓名">
                    <el-input v-model.trim="search.name" clearable style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model.trim="search.id_card" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="search.status" placeholder="全部" clearable style="width:120px">
                        <el-option label="已申请" value="0"></el-option>
                        <el-option label="已审核" value="1"></el-option>
                        <el-option label="审核不通过" value="-1"></el-option>
                        <el-option label="已收费" value="2"></el-option>
                        <el-option label="已报告" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核时间">
                    <el-date-picker v-model="search.audit_at" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        style="width: 260px" />
                </el-form-item>
            </zk-search-form-inline>
        </template>

        <el-table-column type="index" width="50" align="center" />
        <el-table-column prop="secondary_unit" label="二级单位" width="150" align="center" />
        <el-table-column prop="name" label="姓名" width="100" align="center" />
        <el-table-column prop="id_card" label="身份证号" width="170" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0" type="primary" size="mini">已申请</el-tag>
                <el-tag v-else-if="scope.row.status == 1" type="success" size="mini">已审核</el-tag>
                <el-tag v-else-if="scope.row.status == -1" type="danger" size="mini">审核不通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2" type="warning" size="mini">已收费</el-tag>
                <el-tag v-else-if="scope.row.status == 3" type="success" size="mini">已报告</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="items" label="检查项目" align="center" width="200">
            <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.items" :key="index" size="mini" style="margin-right: 5px;">{{
                    item }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="total_cost" label="费用合计" width="100" align="center">
            <template slot-scope="scope">
                {{ scope.row.total_cost }} 元
            </template>
        </el-table-column>
        <el-table-column prop="created" label="申请时间" width="160" align="center" />
        <el-table-column prop="created_by" label="申请人" width="100" align="center" />
        <el-table-column prop="hospital" label="体检机构" width="190" align="center" />
        <el-table-column prop="expert_name" label="研判专家姓名" width="120" align="center" />
        <el-table-column prop="audit_at" label="审核时间" width="160" align="center" />
        <el-table-column prop="audit_by" label="审核人" width="100" align="center" />
        <el-table-column prop="audit_reason" label="审核意见" width="200" align="center" />

        <el-table-column align="center" width="140" label="操作" fixed="right">
            <template slot-scope="scope">
                <el-button v-if="canUpload(scope.row)" size="mini" type="primary" @click="handleOpenUpload(scope.row)">
                    上传报告
                </el-button>
                <el-button v-else-if="hasReport(scope.row)" size="mini" @click="handleViewReport(scope.row)">
                    查看
                </el-button>
                <span v-else style="color:#909399">-</span>
            </template>
        </el-table-column>

        <template v-slot:dialog>
            <el-dialog title="上传体检报告" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false"
                destroy-on-close>
                <el-form :model="form" label-width="90px">
                    <el-form-item label="姓名">
                        <el-input :value="form.name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号">
                        <el-input :value="form.id_card" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="检查项目">
                        <div class="item-tags">
                            <el-tag v-for="(item, index) in form.items" :key="index" size="mini"
                                style="margin-right: 5px;">{{ item }}</el-tag>
                        </div>
                    </el-form-item>
                    <el-form-item label="报告文件">
                        <btnUploadImg v-model="form.report" :disabled="false" />
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="uploading" @click="handleSubmitUpload">确 认 上 传</el-button>
                </span>
            </el-dialog>
        </template>
    </zk-admin-table>
</template>

<script>
export default {
    name: 'keycare_report',
    path: '/main/keycare/report',
    meta: {
        title: '精准关怀体检报告上传',
    },
    data() {
        return {
            loading: false,
            uploading: false,
            dialogVisible: false,
            search: {
                name: '',
                id_card: '',
                status: ''
            },
            table: {
                columns: [],
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            },
            form: {
                id: null,
                name: '',
                id_card: '',
                items: [],
                report: [],
            },
            fileList: []
        };
    },
    computed: {
        headers() {
            const token = localStorage.getItem('token')
            return {
                Authorization: `Bearer ${token}`
            }
        }
    },
    methods: {
        handleTableChange(e) {
            this.table = Object.assign({}, this.table, e);
            this.getData();
        },
        hasReport(row) {
            return !!(
                row.report_url ||
                row.report_path ||
                row.report_name ||
                row.report_file ||
                row.report_id ||
                row.report_uploaded
            );
        },
        canUpload(row) {
            return Number(row.status) === 1 && !this.hasReport(row);
        },
        async handleExport() {
            try {
                this.loading = true
                let params = {
                    page: this.table.page,
                    pageSize: this.table.pageSize,
                    ...this.search
                }
                params.export = 'xlsx'//'csv'
                const resp = await this.$http.get(`/keycare/register`, { params: params, responseType: 'blob' })
                let blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats;charset=utf-8;' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = decodeURI(escape(resp.headers['content-disposition'].split('=')[1]))
                link.click()
                window.URL.revokeObjectURL(link.href)
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        },
        async getData() {
            this.loading = true;
            try {
                const resp = await this.$http.get('/keycare/register', {
                    params: {
                        page: this.table.page,
                        pageSize: this.table.pageSize,
                        ...this.search
                    }
                });
                this.table.data = resp.data.data || [];
                this.table.total = resp.data.total || 0;
            } catch (e) {
                this.$message.error(e.message || '获取数据失败');
            }
            this.loading = false;
        },
        handleOpenUpload(row) {
            this.form = Object.assign({
                id: null,
                name: '',
                id_card: '',
                items: [],
                report: [],
            }, JSON.parse(JSON.stringify(row)));
            this.fileList = [];
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.upload) this.$refs.upload.clearFiles();
            });
        },
        handleExceed() {
            this.$message.warning('仅允许选择一个 PDF 文件');
        },
        beforeUploadPdf(file) {
            const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isPdf) {
                this.$message.error('只能上传 PDF 文件');
                return false;
            }
            if (!isLt20M) {
                this.$message.error('文件大小不能超过 20MB');
                return false;
            }
            this.fileList = [file];
            return false;
        },
        onProgress() {
            this.loading = true
        },
        onSuccess(resp, file, fileList) {
            console.log(resp, file, fileList)
            if (resp.code === 200)
                this.$message.success(resp.msg)
            else
                this.$message.error(resp.msg)
            this.loading = false
        },
        onError(err) {
            // console.log(err)
            this.$message.error('导入失败！')
            this.loading = false
        },
        handleRemoveFile() {
            this.fileList = [];
        },
        async handleSubmitUpload() {
            const file = this.form.report
            if (!file) {
                this.$message.warning('请先选择 PDF 报告文件');
                return;
            }
            if (!this.form.id) {
                this.$message.error('记录ID缺失，无法上传');
                return;
            }

            const fd = new FormData();
            fd.append('id', this.form.id);
            fd.append('report', this.form.report);

            this.uploading = true;
            try {
                // const resp = await this.$http.post('/keycare/report/upload', fd, {
                //     headers: { 'Content-Type': 'multipart/form-data' }
                // });
                const resp = await this.$http.post('/keycare/report/upload', {
                    id: this.form.id,
                    report: this.form.report[0].name,
                    report_url: this.form.report[0].url,
                });
                const status = resp.data.status || 'success';
                const msg = resp.data.msg || '上传成功';
                this.$message[status](msg);
                if (status === 'success') {
                    this.dialogVisible = false;
                    this.getData();
                }
            } catch (e) {
                this.$message.error(e.message || '上传失败');
            }
            this.uploading = false;
        },
        async handleViewReport(row) {
            const directUrl = row.report_url || row.report_path;
            if (directUrl) {
                window.open(directUrl, '_blank');
                return;
            }
            try {
                const resp = await this.$http.get(`/keycare/report/${row.id}`, { responseType: 'blob' });
                if (resp.data && resp.data.type && resp.data.type.indexOf('application/json') > -1) {
                    this.$message.error('报告文件不存在或暂不可查看');
                    return;
                }
                const blob = new Blob([resp.data], { type: 'application/pdf;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                window.URL.revokeObjectURL(url);
            } catch (e) {
                this.$message.error(e.message || '查看报告失败');
            }
        }
    },
    mounted() {
        this.getData();
    }
};
</script>

<style lang="scss" scoped>
.item-tags {
    min-height: 28px;
    line-height: 28px;
}

.upload-box ::v-deep .el-upload {
    width: 100%;
}

.upload-box ::v-deep .el-upload-dragger {
    width: 100%;
}
</style>
